module.exports = __webpack_public_path__ + "media/welcomevideo.963e0daf.mp4";